<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" style="background:rgba(0,0,0,.5);">
    <div :class="[
      'modal-dialog',
      sizeClass,
      'modal-dialog-centered',
      'modal-fullscreen-sm-down'
    ]">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button class="btn-close" :disabled="closeDisabled" @click="requestClose"></button>
        </div>
        <div class="modal-body p-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { lockModalBodyScroll, unlockModalBodyScroll } from '@/utils/modalBodyLock.js'

const props = defineProps({
  show: Boolean,
  size: { type: String, default: 'xxxl' },
  closeDisabled: { type: Boolean, default: false },
})
const emit = defineEmits(['close'])

function requestClose() {
  if (props.closeDisabled) return
  emit('close')
}

const sizeClass = computed(() => {
  const map = {
    sm: 'modal-sm',
    lg: 'modal-lg',
    xl: 'modal-xl',
    xxl: 'modal-xxl',
    xxxl: 'modal-xxxl',    
    fluid: 'modal-fluid',   
    fullscreen: 'modal-fullscreen'
  }
  return map[props.size] || 'modal-xxxl'
})

const onKeyDown = (e) => {
  if (e.key === 'Escape' && props.show && !props.closeDisabled) emit('close')
}

watch(
  () => props.show,
  (visible) => {
    if (visible) lockModalBodyScroll()
    else unlockModalBodyScroll()
  },
  { immediate: true },
)

onMounted(() => document.addEventListener('keydown', onKeyDown))
onUnmounted(() => {
  document.removeEventListener('keydown', onKeyDown)
  if (props.show) unlockModalBodyScroll()
})
</script>

<style>
.modal-xxl {
  max-width: min(1200px, 95vw);
}

.modal-fluid {
  max-width: 98vw;
}

@media (min-width: 576px) {
  .modal-xxxl {
    max-width: min(1800px, 80vw);
    width: min(1800px, 80vw);
    --bs-modal-margin: 10vh;
  }

  .modal-xxxl.modal-dialog {
    height: calc(100vh - 20vh);
    margin: 10vh auto;
    align-items: stretch;
  }

  .modal-xxxl .modal-content {
    height: 100%;
    min-height: calc(100vh - 20vh);
    max-height: calc(100vh - 20vh);
  }
}

@media (min-width: 1400px) {

  .modal-xxxl,
  .modal-fluid {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
